import Ajax from "Pub/js/ajax";
import { setStore } from "Pub/js/storageUtils";
import { langCheck } from "Pub/js/utils";
import platform from "Pub/js/platform";
import DataURL from "./DataURL";
const { QUERYSETTINGURL, QUERYUSERIMAGEURL, MERGEREQUESTURL } = DataURL;
const { ajax } = platform;
const CODEFORAPP = "10228888"; // 首页  应用编码

/**
 * 合并请求
 * @param {Function} callback 各个功能个模块的初始化操作
 */
const APPDataStoreInit = callback => {
    const reqData = [
        {
            rqUrl: QUERYSETTINGURL, // 用户信息查询接口
            rqCode: "querypersonsettings"
        },
        {
            rqUrl: QUERYUSERIMAGEURL, // 用户头像查询接口
            rqCode: "queryuserimage"
        },
    ];
    //2111改为platform的ajax，为了发多时区请求
    ajax({
        url: MERGEREQUESTURL, // 合并请求接口
        data: reqData,
        sysAppcode: CODEFORAPP,
        loading: true,
        success: ({ data }) => {
            if (data) {
                /**
                 * 合并请求 预警信息 全局上下文参数
                 * @param {Object} querypersonsettings 全局上下文信息
                 * @param {String} queryuserimage 用户头像
                 */
                let { querypersonsettings, queryuserimage } = data;
                
                // 全局上下文信息
                if (querypersonsettings) {
                    // 这里处理一下languageMetas数据（如果index为1，变成''，之后给后台的数据要求的是''）
                    if (querypersonsettings.langseq == '1') {
                        querypersonsettings.langseq = '';
                    }
                    const lang1 = querypersonsettings.languageMetas.find(l => l.index == '1');
                    if (lang1) {
                        lang1.index = '';
                    }

                    querypersonsettings.originalBizDateTime = querypersonsettings.bizDateTime; // 记录原始的业务日期
                    querypersonsettings.businessDateChanged = false;
                    setStore("STOREFORINFODATA", querypersonsettings, true);
                    const { im, vpa } = querypersonsettings;
                    setStore("STOREFORSYSTEM", {
                        im,
                        vpa
                    }, false);
                    // 2111增加时区开关
                    const { timezone, timezoneswitch } = querypersonsettings;
                    if (timezone !== undefined && timezoneswitch !== undefined) {
                        const NCC_SYS_Timezone = { timezone, timezoneswitch };
                        localStorage.setItem('NCC_SYS_Timezone', JSON.stringify(NCC_SYS_Timezone));
                    }
                }

                // 用户头像
                if (queryuserimage) {
                    if (queryuserimage.status) {
                        setStore(
                            "STOREFORUSERAVATAR",
                            queryuserimage.imageUrl
                        );
                    }
                }

                // 各个功能模块的初始操作
                callback();
            }
        }
    });
};

export default APPDataStoreInit;
